var errors = {
  500: {
    DEFAULT: 'Sucedio un error desconocido al realizar la petición al servidor. Por favor contacte a soporte.'
  },
  401: {
    DEFAULT: 'Debe estar autenticado para poder acceder a este recurso',
    AUTH_INVALID_CREDENTIALS: 'Usuario y/o contraseña incorrectos',
    AUTH_TOKEN_COMPROMISED: 'Se han utilizado sus credenciales para iniciar sesión desde otro equipo.',
    AUTH_TOKEN_REVOKED: 'Debe de autenticarse nuevamente para utilizar la plataforma.',
    AUTH_TOKEN_EXPIRED: 'Su sesión ha expirado. Debe de autenticarse nuevamente para utilizar la plataforma.',
    AUTH_TOKEN_INVALID: 'No reconocemos su sesión. Debe de autenticarse nuevamente para utilizar la plataforma.',
    UNAUTHHORIZED: 'No estas logueado como empleado.'
  },
  404: {
    DEFAULT: 'El recurso no fue encontrado',
    NOT_FOUND_EMAIL: 'No pudimos encontrar una cuenta con esa dirección de correo electrónico.',
    NOT_FOUND: 'No se encontró la petición en el servidor'
  },
  406: {
    INVALID_QUANTITY: 'No hay existencias disponibles.'
  },
  412: {
    EMAIL_FOUND: 'Ya te encuentras registrado.'
  },
  442: {
    DEFAULT: 'Existen errores de validación en la forma'
  },
  422: {
    DEFAULT: 'Existen errores de validación en la forma',
    UNPROCESSABLE_ENTITY: 'El correo electrónico ya se encuentra registrado'
  },
  429: {
    DEFAULT: 'Demasiados intentos para acceder a la petición.'
  }
};

var getError = function getError(status) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DEFAULT';

  var _status = errors[status] ? status : 500;

  var _code = errors[_status][code] ? code : 'DEFAULT';

  return errors[_status][_code];
};

export default getError;